import React, { useState } from "react";
import "./AddInputForm.css";
import Button from "../../../components/Button/Button";
import TextInput from "../../../components/TextInput/TextInput";

const AddInputForm = ({
	array,
	milesInputs,
	weekInputs,
	setMilesInputs,
	setWeekInputs,
	setShowAddInput,
}) => {
	const [name, setName] = useState({
		value: "",
		error: "",
	});
	const [val, setVal] = useState({
		value: "",
		error: "",
	});

	/**
	 * Main Functions
	 */
	const handleAddLoad = async () => {
		if (checkErrors()) {
			var obj = {
				name: name.value,
				value: val.value,
			};

			if (array === 1) {
				setMilesInputs([...milesInputs, obj]);
			} else if (array === 2) {
				setWeekInputs([...weekInputs, obj]);
			}
			setShowAddInput(false);
		}
	};

	/**
	 * Utility Functions
	 */
	function checkErrors() {
		var noErrors = true;
		if (name.value === "") {
			setName({ value: "#", error: "*Name cannot be empty" });
			noErrors = false;
		}
		if (val.value < 0 || val.value === "") {
			setVal({ value: "", error: "*Value cannot be empty" });
			noErrors = false;
		}
		return noErrors;
	}
	return (
		<div className="AddInputForm">
			<div className="rectangle flex flex-col items-center">
				<h1 className="font-semibold text-2xl mb-7">
					Add New {array === 1 ? "Miles" : "Week"} Cost
				</h1>
				{/* <TextInput
					placeholder={"Name"}
					className={"shadow-none"}
					type={"text"}
					name={"name"}
					id={"name"}
					value={name.value}
					onChange={(e) => {
						setName({ value: e.target.value, error: "" });
					}}
					error={name.error !== ""}
					errorMessage={name.error}
				/> */}

				<div className="SelectInput">
					<select
						name="name"
						id="name"
						onChange={(e) => {
							setName({ value: e.target.value, error: "" });
						}}
					>
						<option value="#" disabled selected>
							Name
						</option>

						<option value="Truck Wash">Truck Wash</option>
						<option value="Washout">Washout</option>
						<option value="Other">Other</option>
					</select>
				</div>
				{name.error !== "" && (
					<p className="error-text text-left text-sm">{name.error}</p>
				)}

				<TextInput
					placeholder={"Value"}
					className={"mt-6 shadow-none"}
					type={"number"}
					name={"val"}
					id={"val"}
					value={val.value}
					onChange={(e) => {
						setVal({ value: e.target.value, error: "" });
					}}
					error={val.error !== ""}
					errorMessage={val.error}
				/>

				<Button
					mode={"filled"}
					size={"lg-1"}
					title={"CREATE COST"}
					className={"mt-7"}
					onClick={() => handleAddLoad()}
				/>
			</div>
		</div>
	);
};

export default AddInputForm;
